// Datos mock para el sistema

export interface Rol {
  id: string;
  nombre: string;
}

export interface Empleado {
  id: string;
  nombres: string;
  apellidos: string;
  telefono: string;
  correo: string;
  dpi: string;
  idRol: string;
  puesto: string;
}

export interface Usuario {
  id: string;
  usuario: string;
  idEmpleado: string;
}

export interface Agente {
  id: string;
  usuario: string;
  agente: string;
  negocio: string;
  propietario: string;
  ubicacion: string;
  idEmpleado: string;
}

export interface Cierre {
  id: string;
  idAgente: string;
  fecha: string;
  hora: string;
  saldoCaja: number;
  saldoSistema: number | null;
  estado: 'Cuadrado' | 'Faltante' | 'Sobrante' | 'Pendiente';
  diferencia: number;
  editado: boolean;
  billetes: {
    q200: number;
    q100: number;
    q50: number;
    q20: number;
    q10: number;
    q5: number;
    q1: number;
  };
  monedas: {
    q1: number;
    q050: number;
    q025: number;
    q010: number;
    q005: number;
    q001: number;
  };
}

export const roles: Rol[] = [
  { id: '1', nombre: 'Administrador' },
  { id: '2', nombre: 'Operador' },
  { id: '3', nombre: 'Supervisor' },
];

export const empleados: Empleado[] = [
  { id: '1', nombres: 'Carlos', apellidos: 'Administrador', telefono: '1234-5678', correo: 'admin@sistema.com', dpi: '1234567890101', idRol: '1', puesto: 'Administrador General' },
  { id: '2', nombres: 'Juan', apellidos: 'Pérez García', telefono: '5555-1234', correo: 'juan.perez@correo.com', dpi: '2345678901234', idRol: '2', puesto: 'Operador de Caja' },
  { id: '3', nombres: 'María', apellidos: 'López Martínez', telefono: '5555-5678', correo: 'maria.lopez@correo.com', dpi: '3456789012345', idRol: '2', puesto: 'Operador de Caja' },
  { id: '4', nombres: 'Ana', apellidos: 'Rodríguez Torres', telefono: '5555-9012', correo: 'ana.rodriguez@correo.com', dpi: '4567890123456', idRol: '2', puesto: 'Operador de Caja' },
  { id: '5', nombres: 'Pedro', apellidos: 'González Ramírez', telefono: '5555-3456', correo: 'pedro.gonzalez@correo.com', dpi: '5678901234567', idRol: '3', puesto: 'Supervisor' },
];

export const usuarios: Usuario[] = [
  { id: '1', usuario: 'admin', idEmpleado: '1' },
  { id: '2', usuario: 'operador1', idEmpleado: '2' },
  { id: '3', usuario: 'operador2', idEmpleado: '3' },
];

export const agentes: Agente[] = [
  { id: '1', usuario: 'ag001', agente: 'Agente Centro', negocio: 'Tienda La Paz', propietario: 'Roberto Méndez', ubicacion: 'Zona 1, Guatemala', idEmpleado: '2' },
  { id: '2', usuario: 'ag002', agente: 'Agente Sur', negocio: 'Super Express', propietario: 'Luisa Hernández', ubicacion: 'Zona 11, Guatemala', idEmpleado: '3' },
  { id: '3', usuario: 'ag003', agente: 'Agente Norte', negocio: 'Comercial El Triunfo', propietario: 'Jorge Castillo', ubicacion: 'Zona 18, Guatemala', idEmpleado: '4' },
];

export const cierres: Cierre[] = [
  {
    id: '1',
    idAgente: '1',
    fecha: '2026-02-05',
    hora: '18:30',
    saldoCaja: 15420.50,
    saldoSistema: 15500.00,
    estado: 'Faltante',
    diferencia: -79.50,
    editado: false,
    billetes: { q200: 50, q100: 30, q50: 20, q20: 15, q10: 10, q5: 5, q1: 20 },
    monedas: { q1: 10, q050: 15, q025: 20, q010: 10, q005: 5, q001: 0 },
  },
  {
    id: '2',
    idAgente: '2',
    fecha: '2026-02-05',
    hora: '19:00',
    saldoCaja: 12300.00,
    saldoSistema: 12300.00,
    estado: 'Cuadrado',
    diferencia: 0,
    editado: false,
    billetes: { q200: 40, q100: 25, q50: 15, q20: 10, q10: 5, q5: 0, q1: 0 },
    monedas: { q1: 0, q050: 0, q025: 0, q010: 0, q005: 0, q001: 0 },
  },
  {
    id: '3',
    idAgente: '3',
    fecha: '2026-02-05',
    hora: '18:45',
    saldoCaja: 18750.75,
    saldoSistema: 18700.00,
    estado: 'Sobrante',
    diferencia: 50.75,
    editado: true,
    billetes: { q200: 60, q100: 40, q50: 25, q20: 20, q10: 15, q5: 10, q1: 5 },
    monedas: { q1: 5, q050: 10, q025: 15, q010: 5, q005: 5, q001: 0 },
  },
  {
    id: '4',
    idAgente: '1',
    fecha: '2026-02-04',
    hora: '18:15',
    saldoCaja: 14200.00,
    saldoSistema: 14200.00,
    estado: 'Cuadrado',
    diferencia: 0,
    editado: false,
    billetes: { q200: 45, q100: 28, q50: 18, q20: 12, q10: 8, q5: 4, q1: 0 },
    monedas: { q1: 0, q050: 0, q025: 0, q010: 0, q005: 0, q001: 0 },
  },
  {
    id: '5',
    idAgente: '2',
    fecha: '2026-02-04',
    hora: '18:50',
    saldoCaja: 11850.25,
    saldoSistema: null,
    estado: 'Pendiente',
    diferencia: 0,
    editado: false,
    billetes: { q200: 38, q100: 22, q50: 14, q20: 8, q10: 5, q5: 2, q1: 0 },
    monedas: { q1: 0, q050: 5, q025: 0, q010: 0, q005: 5, q001: 0 },
  },
];
